import React, { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { setSession } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const m = location.hash.match(/session_id=([^&]+)/);
    const p = location.pathname;
    const target = p.startsWith("/admin") ? "/admin" : /^\/(tecnici|kappa|easylab26)/.test(p) ? "/tecnici" : "/area-clienti";
    if (!m) { navigate(target, { replace: true }); return; }
    api.post("/auth/google/session", { session_id: m[1] })
      .then(({ data }) => {
        setSession(data.token, data.user);
        if (target === "/admin" && data.user.role !== "admin") toast.error("Questo account Google non è abilitato come amministratore");
        if (target === "/tecnici" && !["technician", "admin"].includes(data.user.role)) toast.error("Questo account Google non è abilitato come tecnico: chiedi al titolare di inserire la tua email in Admin → Tecnici");
        navigate(target, { replace: true, state: { user: data.user } });
      })
      .catch(() => { toast.error("Accesso con Google non riuscito"); navigate(target, { replace: true }); });
  }, []); // eslint-disable-line

  return null;
};

export default AuthCallback;
